import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { callMethod } from '../../../common/utilsClient/ddp/actions';
import { apiZedocGetClinicians } from '../../../common/api/zedoc';

/**
 * Custom hook to fetch list of clinicians from OMOP database
 *
 * @returns {Object} { clinicians: Array, loading: boolean, error: Error | null }
 */
export const useClinicians = () => {
  const dispatch = useDispatch();
  const [clinicians, setClinicians] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    dispatch(callMethod(apiZedocGetClinicians, {}))
      .then((result) => {
        setLoading(false);
        setClinicians(result || []);
      })
      .catch((err) => {
        setLoading(false);
        console.error('Error fetching clinicians:', err);
        setError(err);
      });
  }, [dispatch]);

  return {
    clinicians,
    loading,
    error,
  };
};

export default useClinicians;
